import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryLoyaltyPoints.js';
import { RichText } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';

const AvailMainSideSummaryLoyaltyPoints = class AvailMainSideSummaryLoyaltyPoints extends React.Component {
  static displayName = 'AvailMainSideSummaryLoyaltyPoints';

  render() {
    const { config, theme } = this.props,
      {
        accumulatePoints
      } = config;

    const { classes } = theme.styles;

    return (
      <div className={[classes.contentModule].join(' ')}>
        <div className={[classes.contentModuleRow].join(' ')}>
          <div className={[classes.contentModuleCell, classes.large].join(' ')}>
            <RichText text={'_%acumularás%_'} ucFirst={true} innerStyle={['roboto16BoldBlack400', 'capitalize', 'mainColor']} translate={true}/>
          </div>

          <div className={[classes.contentModuleCell, classes.contentModuleCellPrice, classes.short].join(' ')}>
            <RichText text={'_%+{accumulatePoints} puntos%_'} innerStyle={['roboto16BoldBlack400', 'capitalize', 'mainColor']} translate={true} withVars={{accumulatePoints: accumulatePoints}}/>
          </div>
        </div>
      </div>
    );
  }
};

export default compose(
  PropertyManager([
    'accumulatePoints'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryLoyaltyPoints);
